module.exports = __webpack_public_path__ + "img/shipment-add.9c32a79a.svg";